export default __webpack_public_path__ + "static/media/starsBranch.2be87699.svg";